import { Pantry, TefapConfig, User, Visit } from '../../../types';

export type TefapAttestationProps = {
  isVisible: boolean;
  onCancel: () => void;
  translation: { [key: string]: string };
  registration: {
    user: Partial<
      Pick<
        User,
        | 'state'
        | 'address_street_1'
        | 'address_street_2'
        | 'city'
        | 'zip_code'
        | 'below_min_household_income'
        | 'is_eligible_for_tefap'
        | 'assistance_programs'
      >
    >;
    tefapConfig: TefapConfig;
  };
  actions: { [key: string]: Function };
  visit: Partial<Pick<Visit, 'id' | 'pantry_id' | 'tefap_attestation'>>;
  pantry: Partial<Pick<Pantry, 'id' | 'pantry_id' | 'state'>>;
  organizationId: number;
};
